import { useMessageTypesQuery, MessageType } from 'api/MessageTypeAPI';
import { keyBy } from 'utils/arrayHelpers';

export const useMessageTypes = () => {
  const {
    data: messageTypes = [],
    isLoading: isLoadingMessageTypes,
    refetch: refetchMessageTypes,
  } = useMessageTypesQuery();

  const messageTypesByChannelId = keyBy(
    messageTypes as MessageType[],
    (type) => type.messageChannelId,
  );

  return { messageTypes, messageTypesByChannelId, isLoadingMessageTypes, refetchMessageTypes };
};
